import { useState } from 'react';
import { FiMail, FiX } from 'react-icons/fi';
import { resendVerificationEmail } from '../../services/profile.service';

const DISMISS_KEY = 'verify_email_banner_dismissed';

/**
 * Non-blocking nudge for a grandfathered (pre-cutoff) user whose email isn't verified.
 * These users are never gated — this only encourages verification. Dismissal is
 * remembered so it doesn't nag.
 */
export default function VerifyEmailBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (dismissed) return null;

  function dismiss() {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* private mode — just hide for this session */
    }
    setDismissed(true);
  }

  async function handleResend() {
    setBusy(true);
    const res = await resendVerificationEmail();
    setSent(res.success);
    setBusy(false);
  }

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-2 text-sm flex items-center gap-3">
      <FiMail className="text-primary shrink-0" />
      <span className="flex-1 min-w-0 text-base-content/80">
        {sent
          ? 'Verification email sent — check your inbox.'
          : 'Verify your email to secure your account.'}
      </span>
      {!sent ? (
        <button
          onClick={() => void handleResend()}
          disabled={busy}
          className="text-primary font-medium hover:underline disabled:opacity-60 shrink-0"
        >
          {busy ? 'Sending…' : 'Resend'}
        </button>
      ) : null}
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-base-content/40 hover:text-base-content shrink-0"
      >
        <FiX />
      </button>
    </div>
  );
}
